export default __webpack_public_path__ + "files/PDL Team Button-9f83e9f083116970f7cd750f7997d209.png";